
import axios from "axios";
import customModal from '../customModal/customModal.vue';
import store from "../../store/index";


export default {
    name: "",
    components: {
        customModal
    },
       props: {
        meddraItem: Object,
        templateId: String,
        formsId: String
       
    },
    data() {
        return {
            
            suggestions: [],
            socket: null,
            typingTimeout: null,
            isSuggestionSelected: false,

            showMeddraModal: false,
            baseapi: process.env.VUE_APP_Service_URL,
            formId: "",
            tempId: "",
            meddra: {
                FieldName: "",
                LltName: ""
            },
            meddraEditValue: ""
        }
    },
    
    mounted() {
        this.socket = new WebSocket("wss://ids-dev.datamatica.uk/v1/medicalcoding-python/meddrahub/search");

        this.socket.onopen = () => console.log("WebSocket connected");
        this.socket.onclose = () => console.log("WebSocket disconnected");
        this.socket.onerror = err => console.error("WebSocket error:", err);
        this.socket.onmessage = (event) => {
        try {
            const data = JSON.parse(event.data);
            if (Array.isArray(data)) {
            this.suggestions = data.map(obj => {
                const [key, value] = Object.entries(obj)[0];
                return { value };
            });
            }
        } catch (e) {
            console.error("Invalid JSON:", event.data);
        }
        };
    },

    methods: {
        
        onInputChange() {
            
            this.isSuggestionSelected = false; // Reset when user types
            clearTimeout(this.typingTimeout);
            this.typingTimeout = setTimeout(() => {
                const text = this.meddraEditValue.trim();
                if (text && this.socket.readyState === WebSocket.OPEN) {
                this.socket.send(JSON.stringify({ query: text }));
                } else if (!text) {
                this.suggestions = [];
                }
            }, 300);

        },
        selectSuggestion(item) {
            this.meddraEditValue = item.value;
            this.isSuggestionSelected = true;
            this.suggestions = [];
        },

        openMeddraModal() {
            this.showMeddraModal = true;
        },
        closeActivityModal() {
            // this.$emit("closeModal");
            this.$emit("closeModal", { refresh: false }); 
           // this.showMeddraModal = false;
        },
        async saveMeddraEdit() {   
            
            if (!this.isSuggestionSelected) {
                alert("Please select a valid LLT from the suggestions.");
                return;
            }      
        
            const idtoken = store.getters.getIdToken;
            const currentstudy = store.getters.getStudyIs;
            await axios
                .post(
                    `${this.baseapi}/medicalcoding-python/meddra/meddraverifyterms`,
                    {
                        studyid: currentstudy,
                        templateid: this.templateId,
                        formitemid: this.formsId,
                        fielddata: {
                            fieldname: this.meddraItem.FieldName,
                            verifiedlltname: this.meddraEditValue
                        }
                    },
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                )
                .then(async (res) => {
                    console.log(" verifymeddra", res);
                    alert("MedDRA term verified successfully");
                    console.log("Closing modal", this.showMeddraModal);
                    this.showMeddraModal = false;
                    console.log("Closing modal2", this.showMeddraModal);
                    this.$emit("closeModal", { refresh: true });
                    // this.closeActivityModal();
                    //await this.getpatients();
                })
                .catch((err) => {
                    console.log(err);
                });
        }

    }
}